import React, {ReactNode, useEffect, useRef, useState} from 'react';
import styles from './styles.module.scss';
import AriaText from "../../../../components/AriaComponents/AriaText";

type Props = ({
    infoText: string;
    customMark?: never;
    customDisplay?: never;
    className?: string;
} | {
    infoText?: never;
    customMark: ReactNode;
    customDisplay: ReactNode;
    className?: string;
}) & {
    keypad?: boolean
}

const SettingsInfoIcon: React.FC<Props> = ({ infoText, customMark, customDisplay, className, keypad }) => {
    const [show, setShow] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const [position, setPosition] = useState<'left' | 'right'>('right');

    useEffect(() => {
        const checkPosition = () => {
            if (!ref.current) return;
            const rect = ref.current.getBoundingClientRect();
            const spaceRight = window.innerWidth - rect.right;
            const spaceLeft = rect.left;

            if (spaceRight < 600 && spaceLeft > 400) {
                setPosition('left');
            } else {
                setPosition('right');
            }
        };

        checkPosition();
        window.addEventListener('resize', checkPosition);
        return () => window.removeEventListener('resize', checkPosition);
    }, []);

    return (
        <div
            ref={ref}
            className={[styles.info_item, className || ''].join(' ')}
            onMouseEnter={() => setShow(true)}
            onMouseLeave={() => setShow(false)}
        >
            {infoText !== undefined ? (
                <>
                    <mark>i</mark>
                    <AriaText text={infoText}/>
                    {show && (
                        <div
                            data-keypad={keypad || null}
                            className={`${styles.tooltip} ${styles[position]}`}
                        >
                            <p>{infoText}</p>
                        </div>
                    )}
                </>
            ) : (
                <>
                    {customMark}
                    {show && (
                        <div className={`${styles.tooltip} ${styles[position]}`}>
                            {customDisplay}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default SettingsInfoIcon;
